$(document).ready(function () {

    var styledMap = new google.maps.StyledMapType(subtleGrayscaleMapStyle, { name: "Styled Map" });

    var mapElement = $('#mapLocationSrc');

    var map = new google.maps.Map(mapElement.get(0), {
            center: new google.maps.LatLng(latitude, longitude),
            zoom: zoomLevel,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            streetViewControl: false,
            scrollwheel: false,
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }),
        marker = new google.maps.Marker({
            position: new google.maps.LatLng(latitude, longitude),
            map: map,
            icon: markerIcon
        });

    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    // resize map when parent div gets equalized
    mapElement.on('resizeme.zf.trigger', function (e) {
        google.maps.event.trigger(map, 'resize');
    });

    var old_v = '',
        ds = new google.maps.DirectionsService(),
        dr = new google.maps.DirectionsRenderer();
    dr.setMap(map);
    dr.setPanel($('#map-directions-data').get(0));

    $('#frmPostcode').bind('submit', function () {
        var v = $.trim($('#tbPostcode').val());
        if (v != '' && v != old_v) {
            old_v = v;
            var r = {
                origin: v,
                destination: destinationAddress,
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.IMPERIAL
            };
            ds.route(r, function (result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    marker.setMap(null);
                    dr.setDirections(result);
                    $('#map-directions').css({ display: 'block' });
                    $('#print-directions').show();
                    setTimeout(function () {
                        var x = document.getElementById("map-directions-data").innerHTML;
                        var str = x;
                        str = str.replace(/&/g, "amp;");
                        str = str.replace(/>/g, "gt;");
                        str = str.replace(/</g, "lt;");
                        str = str.replace(/"/g, "quot;");
                        str = str.replace(/'/g, "#039;");

                        mapElement.trigger('resizeme.zf.trigger');
                    }, 2000);
                } else {
                    alert('Location ' + old_v + ' not found.');
                }
            });
        }
    });
});

function rgb2hex(rgb) {
    if (!rgb || rgb.indexOf("rgb") == -1) {
        return rgb;
    } else {
        rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);

        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
}

var theme_colour = rgb2hex($('.find-us__directions').css('background-color'));

var subtleGrayscaleMapStyle = [{
        "featureType": "all",
        "elementType": "labels",
        "stylers": [{
            "visibility": "on"
        }]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [{
                "saturation": 36
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [{
            "weight": 1.2
        }]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#333333"
        }]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.stroke",
        "stylers": [{
                "color": "#ababab"
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#333333"
        }]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#f0f0f0"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "labels",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "labels",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
                "lightness": 21
            },
            {
                "color": "#f0f0f0"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
                "color": theme_colour
            },
            {
                "lightness": "0"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [{
                "color": "#a9a9a9"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{
                "color": "#ffffff"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.stroke",
        "stylers": [{
                "color": "#2c2c2c"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{
                "color": "#a9a9a9"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [{
                "color": "#676767"
            },
            {
                "lightness": "0"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
                "color": theme_colour
            },
            {
                "lightness": "0"
            }
        ]
    }
];